import { Div } from "../Div";
import { Tag } from "../Tag";

export class Container extends Div {

    public replaceChildren(elements: Tag[]) {
        this.clear();
        this.appendChildren(elements);
    }

    public appendChildren(elements: Tag[]) {
        elements.forEach((element: Tag) => {
            this.appendChild(element);
        });
    }

    public replaceByTag(tag: Tag) {
        this.clear();
        if (tag) {
            setTimeout(() => {
                this.clear();
                this.appendChild(tag);
            }, 0);
        }
    }

    protected createByType(data: Map<any, any>, main: Tag) {
        const t = data.get("t");
        let tag: any = null;
        switch (t) {
            case "__":
                tag = new Div(data.get("d"));
                tag.addClass("t1");
                break;
            default:
                super.createByType(data, main);
                break;
        }
        if (tag) {
            main.appendChild(tag);
        }
    }
}
